import { FireOutbreakReactionEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireOutbreakReaction } from './FireOutbreakReaction.abstract'

export class OccurredFireOutbreakOptionStrategy extends FireOutbreakReaction {
	constructor() {
		super('Positivo', 'material-symbols:thumb-up-rounded', FireOutbreakReactionEnum.POSITIVE)
	}
}
